/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { Futura } from "../Futura";

export class Futura__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    paymentTokenAddressParam: string,
    redemptionTokenAddressParam: string,
    redemptionTokenIDParam: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Futura> {
    return super.deploy(
      paymentTokenAddressParam,
      redemptionTokenAddressParam,
      redemptionTokenIDParam,
      overrides || {}
    ) as Promise<Futura>;
  }
  getDeployTransaction(
    paymentTokenAddressParam: string,
    redemptionTokenAddressParam: string,
    redemptionTokenIDParam: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      paymentTokenAddressParam,
      redemptionTokenAddressParam,
      redemptionTokenIDParam,
      overrides || {}
    );
  }
  attach(address: string): Futura {
    return super.attach(address) as Futura;
  }
  connect(signer: Signer): Futura__factory {
    return super.connect(signer) as Futura__factory;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Futura {
    return new Contract(address, _abi, signerOrProvider) as Futura;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "paymentTokenAddressParam",
        type: "address",
      },
      {
        internalType: "address",
        name: "redemptionTokenAddressParam",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "redemptionTokenIDParam",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "availableBpmCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "availableCellClipIDs",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "availableCellCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "clipHashToToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "clipNFTAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "discountNFTs",
    outputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "enum Futura.TokenType",
        name: "tokenType",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dropStage",
    outputs: [
      {
        internalType: "enum Futura.DropStage",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "bpmIndex",
        type: "uint8",
      },
      {
        internalType: "uint256[]",
        name: "clipIDs",
        type: "uint256[]",
      },
    ],
    name: "editMaster",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "futuraMetadata",
    outputs: [
      {
        internalType: "contract FuturaMetadata",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "origin",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "numberOfBurns",
        type: "uint256",
      },
    ],
    name: "getRemixPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "sentAmount",
        type: "uint256",
      },
    ],
    name: "getRoyaltyAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getTokenData",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "mixer",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "bpmIndex",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "generation",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "clipIDs",
            type: "uint256[]",
          },
        ],
        internalType: "struct Futura.TokenData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "layerCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    name: "mintManyMixes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "bpmIndex",
        type: "uint8",
      },
      {
        internalType: "uint256[]",
        name: "clipIDs",
        type: "uint256[]",
      },
    ],
    name: "mintMaster",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintMix",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenIdLeft",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenIdRight",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "bpmIndex",
        type: "uint8",
      },
      {
        internalType: "uint256[]",
        name: "clipIDs",
        type: "uint256[]",
      },
    ],
    name: "mintRemixWithNoBurn",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenIdLeftKeep",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenIdRightBurn",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "bpmIndex",
        type: "uint8",
      },
      {
        internalType: "uint256[]",
        name: "clipIDs",
        type: "uint256[]",
      },
    ],
    name: "mintRemixWithOneBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenIdLeftBurn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenIdRightBurn",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "bpmIndex",
        type: "uint8",
      },
      {
        internalType: "uint256[]",
        name: "clipIDs",
        type: "uint256[]",
      },
    ],
    name: "mintRemixWithTwoBurns",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paymentTokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "playerUri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceToRemix",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceToRemixOneBurn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceToRemixTwoBurns",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceToRemixWithPass",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "redemptionTokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "redemptionTokenID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "royaltyBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sectionCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "clipAddress",
        type: "address",
      },
    ],
    name: "setClipNFTAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tokenAddresses",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "enum Futura.TokenType[]",
        name: "tokenTypes",
        type: "uint8[]",
      },
    ],
    name: "setDiscountNFTs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setEditMastersLock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setEditRemixPriceLock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setEditRoyaltyBpsLock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "sectionCountParam",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "layerCountParam",
        type: "uint256",
      },
    ],
    name: "setLayout",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "metadataAddress",
        type: "address",
      },
    ],
    name: "setMetadataAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "paymentTokenAddressParam",
        type: "address",
      },
    ],
    name: "setPaymentTokenAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "playerUriParam",
        type: "string",
      },
    ],
    name: "setPlayerUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "remixPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "remixOneBurnPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "remixTwoBurnPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "remixWithPassPrice",
        type: "uint256",
      },
    ],
    name: "setPrices",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "redemptionTokenAddressParam",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "redemptionTokenIDParam",
        type: "uint256",
      },
    ],
    name: "setRedemptionTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "royaltyBpsParam",
        type: "uint256",
      },
    ],
    name: "setRoyaltyBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Futura.DropStage",
        name: "stage",
        type: "uint8",
      },
    ],
    name: "setStage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bpmCount",
        type: "uint256",
      },
    ],
    name: "setupBpmCount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "cellIDs",
        type: "uint256[]",
      },
      {
        internalType: "uint256[][]",
        name: "cellClipIDs",
        type: "uint256[][]",
      },
    ],
    name: "setupCells",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenData",
    outputs: [
      {
        internalType: "address",
        name: "mixer",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "bpmIndex",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "generation",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
